import request from '../request'
export function uploadFile(option: any) {
  const formData = new FormData()
  formData.append("files", option.file)
  return request({
    url: "/api/common/upload_image",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: option.uploadProgress ? option.uploadProgress : () => {}
  })
}

export function uploadVideo(option: any) {
  const formData = new FormData()
  formData.append("file", option.file)
  return request({
    url: "/api/common/upload_video",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: option.uploadProgress ? option.uploadProgress : () => {}
  })
}